.formFieldContainer {
    flex: 1;
    margin: 0px 10px 10px 10px;
}

.deleteButton {
    margin-right: auto;
}
